module.exports = __webpack_public_path__ + "media/images/icon-linked-accounts-3d6aa4f6ae064c1c5e7bbf1821470812.svg";